import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../../assets/images/complete-id.png'


const _hoisted_1 = { class: "modal_content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "r2xl:!tw-max-w-[61%]" }, "Great job! 🥳", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Now, for your safety and others"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" we now need to, complete your ID verification (KYC) ")
], -1)
const _hoisted_5 = { class: "tw-grid tw-gap-4 tw-grid-cols-2 tw-w-full s540:!tw-flex s540:!tw-flex-col-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!
  const _component_WorkstationVerificationModal = _resolveComponent("WorkstationVerificationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CommonDialog, {
      isShowHeader: false,
      isShowBackButton: false,
      width: "600px",
      "max-width": "100%",
      className: ['setting_up_preview_modal']
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_icon, {
            icon: "mdi-close",
            class: "close_icon",
            onClick: $setup.onClickCloseButton
          }, null, 8, ["onClick"]),
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              onClick: $setup.onClickCloseButton,
              variant: "secondary",
              label: "Cancel"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              onClick: $setup.onClickStatusModalContinue,
              label: "Complete ID Verification"
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }),
    ($setup.openedModel === $setup.modelName.VERIFYMODAL)
      ? (_openBlock(), _createBlock(_component_WorkstationVerificationModal, {
          key: 0,
          onClickCloseTab: $setup.onClickCloseModel
        }, null, 8, ["onClickCloseTab"]))
      : _createCommentVNode("", true)
  ], 64))
}